module.exports = __webpack_public_path__ + "img/AP_ico_question.02b02bef.svg";